exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".complete-level{text-align:center}.complete-level .modal-content,.complete-level .modal-content h3{font-family:brandon-grotesque,Helvetica,Arial,sans-serif}.complete-level .btn{width:100%;white-space:normal;min-height:4em;text-transform:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/session/presentation/components/completeLevelModal.scss
// module id = 1308
// module chunks = 2